import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

import ResourceCard, { ResourceCardContentProps } from "./resource-card";

const resourceCardsStyling = css({
    display: "flex",
    flexDirection: "column"
});

const ProductFeaturesResourceCards = () => {
    const intl = useIntl();

    const roadMapsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.ViewRoadmaps",
        defaultMessage: "View roadmaps"
    });
    const advancedFeaturesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.AdvancedFeatures",
        defaultMessage: "See advanced features"
    });
    const browseResourcesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.BrowseResources",
        defaultMessage: "Browse resources"
    });

    const productFeaturesResourceCards: ResourceCardContentProps[] = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.FeatureRoadmaps",
                defaultMessage: "Feature Roadmaps"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.FeatureRoadmaps.dsc",
                defaultMessage:
                    "See what's in our pipeline for Cloud and Data Center products."
            }),
            buttonText: roadMapsText,
            url: useLocalizedHref("/roadmap/cloud")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.CloudPremium",
                defaultMessage: "Cloud Premium products"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.CloudPremium.dsc",
                defaultMessage:
                    "Learn about advanced product features for enterprises."
            }),
            buttonText: advancedFeaturesText,
            url: useLocalizedHref("/software/premium")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.EnterpriseResources",
                defaultMessage: "More enterprise resources"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.EnterpriseResources.dsc",
                defaultMessage:
                    "View resources, filtered by Cloud and Data Center product features."
            }),
            buttonText: browseResourcesText,
            url: useLocalizedHref(
                "/enterprise/resources?format=&topic=product-features&platform="
            )
        }
    ];

    return (
        <div css={resourceCardsStyling}>
            {productFeaturesResourceCards.map((cardProps) => (
                <ResourceCard {...cardProps} key={cardProps.header} />
            ))}
        </div>
    );
};

export default ProductFeaturesResourceCards;
